/**
 * Icons - Vertical Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initIconsVertical() {
        const blocks = document.querySelectorAll('.icons-vertical');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] icons-vertical block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initIconsVertical);
    } else {
        initIconsVertical();
    }
})();